import React, { useEffect, useState } from 'react'
//*Material
import Grid from '@material-ui/core/Grid'
import withStyles from '@material-ui/core/styles/withStyles'
import Typography from '@material-ui/core/Typography'
import Button from "@material-ui/core/Button"
import { makeStyles } from '@material-ui/core/styles'
import Tab from "@material-ui/core/Tab"
import TabContext from "@material-ui/lab/TabContext"
import TabList from "@material-ui/lab/TabList"
import TabPanel from "@material-ui/lab/TabPanel"
import { FormControl, Input, TextField } from '@material-ui/core'
import Container from '@material-ui/core/Container'
import AppBar from "@material-ui/core/AppBar"
import IconButton from '@material-ui/core/IconButton'
import Divider from '@material-ui/core/Divider'
import DeleteForeverIcon from '@material-ui/icons/DeleteForever'
import DataTable from 'react-data-table-component'
import CircularProgress from "@material-ui/core/CircularProgress"
import Backdrop from '@material-ui/core/Backdrop'
//*antd
import Modal from 'antd/es/modal';
//*Styles and Assets
import { TelematicsStyles } from './TelematicsStyles'
import { useTranslation } from 'react-i18next'
//*Redux
import { connect } from "react-redux"
import { useHistory } from 'react-router-dom'
import { bindActionCreators } from 'redux'
import * as navigationActions from '../../actions/common/NavigationActions'
import * as TelematicsActions from '../../actions/telematics/TelematicsActions'
//*Components
import TopBarNav from '../common/TopBarNav'
import BreadcrumbsHistory from '../common/BreadcrumbsHistory'
import { customStyleSecondary } from '../common/CommonStyles'
import UseForm from '../common/UseForm'
import Tooltip from '@material-ui/core/Tooltip'
import ServiceFinalization from '../telematics/Evidences/ServiceFinalization'

const useStyles = makeStyles({
    cardHeader: {
        backgroundColor: "#7a9bc2",
        color: "white"
    },
    stageButton: {
        backgroundColor: "#063452",
        color: "white"
    },
    denyButton: {
        backgroundColor: "white"
    },
    pdfButton: {
        backgroundColor: "white"
    },
    appbar: {
        backgroundColor: "White",

    },
    tab: {
        backgroundColor: '#A5A5A5',
        '&.Mui-selected': {
            backgroundColor: '#789AC1'
        },
        borderTopRigthRadius: "15%",
        textTransform: "capitalize"
    },
    indicator: {
        backgroundColor: "#7a9bc2"
    },
    checked: {
        '&$checked': {
            color: "#7a9bc2"
        }
    }
})

const TelematicsUploadEvidence = ({ classes, ...props }) => {
    const { t } = useTranslation();
    const localclass = useStyles();
    const history = useHistory()
    const [openBackdrop, setOpenBackdrop] = useState(false);
    const [value, setValue] = useState("1");
    const { match: { params } } = props
    const [uploadedFile, setUploadedFile] = useState(false)

    const paginationOptions = { rowsPerPageText: t('commonMessages.rowsPerPage'), rangeSeparatorText: t('common.to'), selectAllRowsItem: true, selectAllRowsItemText: t('common.all') }

    const initialFieldValues = {
        evidence: {}
    }

    const {
        values,
        handleInpuFileChange
    } = UseForm(initialFieldValues)

    useEffect(() => {
        handleOpenBackdrop()
        const newRoute = {
            path: '/telematics/UploadEvidence/',
            linkLegend: t('telematicsDetail.uploadEvidence'),
        }
        props.navigationActions.add_route(newRoute)
        props.actions.fetch_Evicence_Service_By_Id(props.userLanguage, props.userToken, params.serviceId, onError, onSuccess)
        return () => {

        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (Object.keys(values.evidence).length !== 0) {
            setUploadedFile(true)
        } else {
            setUploadedFile(false)
        }
    }, [values]) // eslint-disable-line react-hooks/exhaustive-deps

    const handleCloseBackdrop = () => {
        setOpenBackdrop(false);
    }

    const handleOpenBackdrop = () => {
        setOpenBackdrop(true);
    }

    const onSuccess = () => {
        handleCloseBackdrop()
    }

    const onSuccessSave = (response) => {
        handleCloseBackdrop()
        Modal.success({
            title: t('commonMessages.savedSucc')
        })
        props.actions.fetch_Evicence_Service_By_Id(props.userLanguage, props.userToken, params.serviceId, onError, onSuccess)
        Array.from(document.querySelectorAll("input")).forEach(
            input => (input.value = "")
        )
    }

    const onError = (err) => {
        handleCloseBackdrop()
        if (err.response && err.response.status) {
            switch (err.response.status) {
                case 400:
                    Modal.error({
                        title: 'Error',
                        content: t(`telematicsErrors.${err.response.data.errors.ErrorCodes[0]}`)
                    })
                    break
                case 401:
                    props.tokenExpired()
                    history.push('/login')
                    break
                case 403:
                    history.push('/forbidden')
                    break
                case 500:
                    Modal.error({
                        title: 'Error',
                        content: t('commonMessages.alert500')
                    })
                    break
                default:
                    break
            }
        }
    }

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    const checkFileTypes = event => {
        let file = event.target.files[0]
        if (file != null) {
            let types = ['text/csv', 'application/pdf', 'image/png', 'image/jpeg', 'image/jpg',
                'application/msword', 'image/svg+xml',
                'application/vnd.ms-excel']

            if (types.every(type => file.type !== type)) {
                Modal.error({
                    title: 'Error',
                    content: t('commonMessages.unsupportedFormat')
                })
                event.target.value = null
                return false
            } else {
                handleInpuFileChange(event)
            }
        }
    }

    const handleSubmit = e => {
        if (uploadedFile) {
            e.preventDefault()
            handleOpenBackdrop()

            const formData = new FormData()
            formData.append('serviceId', params.serviceId)

            for (let file of values.evidence) {
                formData.append("evidence", file);
            }

            props.actions.update_Service_Evidence(props.userLanguage, props.userToken, params.serviceId, formData, onError, onSuccessSave)
        } else {
            Modal.error({
                title: 'Error',
                content: t('commonMessages.errorUndefined')
            })
        }
    }

    const handleDelete = (evidenceId) => {
        handleOpenBackdrop()
        props.actions.delete_Evidence(props.userLanguage, props.userToken, params.serviceId, evidenceId, onError, onSuccessDelete)
    }

    const onSuccessDelete = (response) => {
        handleCloseBackdrop()
        props.actions.fetch_Evicence_Service_By_Id(props.userLanguage, props.userToken, params.serviceId, onError, onSuccess)
        Modal.success({
            title: t('commonMessages.deletedSucc')
        })
    }

    const columns = [
        {
            name: t('telematicsDetail.fileName'),
            selector: 'fileName',
            sortable: true,
            cell: row => row.fileName
        },
        {
            name: t('collateralDetails.registerDate'),
            selector: 'creationDate',
            sortable: true,
            cell: row => row.creationDate
        },
        {
            name: "",
            selector: 'promoterCost',
            sortable: true,
            width: '150px',
            cell: row => showDeleteEvidence(row)
        }
    ]

    const showDeleteEvidence = (row) => {
        return (
            <Tooltip title={t('common.delete')}>
                <IconButton style={{ color: '#BF2E2E' }} onClick={() => handleDelete(row.id)}>
                    <DeleteForeverIcon />
                </IconButton>
            </Tooltip>
        )
    }

    return (
        <div>
            <TopBarNav />
            <br />
            <BreadcrumbsHistory />
            <br />
            <Container maxWidth="lg" className={classes.root}>
                <Backdrop className={classes.backdrop} open={openBackdrop}>
                    <CircularProgress color="inherit" />
                </Backdrop>
                <Grid container item xs={12} spacing={3} >
                    <Grid item xs={12} >
                        <p className={classes.titles}>{t(`telematicsDetail.uploadEvidence`)}</p>
                    </Grid>
                </Grid>
                <Grid container spacing={1}>
                    <Grid item xs={12} >
                        <TabContext value={value}>
                            <AppBar position="static" elevation={0}>
                                <TabList onChange={handleChange} className={localclass.appbar} TabIndicatorProps={{ className: localclass.indicator }} >
                                    <Tab label={t('telematicsDetail.evidenceRecord')} value="1" className={localclass.tab} />
                                    <Tab label={t('telematicsDetail.serviceFinalization')} value="2" className={localclass.tab} />
                                </TabList>
                            </AppBar>
                            <TabPanel value="1" className={classes.paddingTabPanel}>
                                <Container className={classes.generalBorder}>
                                    <br />
                                    <Grid container direction="row" justify="space-between" alignItems="flex-start" >
                                        <Grid item xs={5} >
                                            <Typography variant="body1" style={{ fontWeight: 600 }}>{t('common.service')}</Typography>
                                            <TextField
                                                value={params.typeService}
                                                fullWidth
                                                disabled={true}
                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid container item xs={12}><br /></Grid>
                                    <Grid container direction="row" justify="space-between" alignItems="flex-start" >
                                        <Grid item xs={5}>
                                            <FormControl fullWidth >
                                                <Typography variant="body1" style={{ fontWeight: 600 }}>{t('telematicsDetail.addEvidence')}</Typography>
                                                <Input
                                                    fullWidth
                                                    type="file"
                                                    name="evidence"
                                                    className="file"
                                                    onChange={checkFileTypes}
                                                />
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={7} className={classes.buttonAlign}>
                                            <br />
                                            <Button type="button" variant="outlined" onClick={handleSubmit} className={classes.generalBorder}>{t('common.save')}</Button>
                                        </Grid>
                                    </Grid>
                                    <Grid container item xs={12}><br /></Grid>
                                    <Divider />
                                    <Grid container item xs={12}><br /></Grid>
                                    <Grid container direction="row" justify="space-between" alignItems="flex-start" >
                                        <DataTable
                                            columns={columns}
                                            data={props.evidences}
                                            defaultSortField="evidenceId"
                                            customStyles={customStyleSecondary}
                                            highlightOnHover
                                            noHeader
                                            dense
                                            responsive
                                            striped
                                            pointerOnHover
                                            pagination
                                            paginationComponentOptions={paginationOptions}
                                            noDataComponent={<p className={classes.marginNoData}>{t('commonMessages.noData')}</p>}
                                        />
                                        {
                                            props.evidences && props.evidences.length < 1 && (
                                                <Grid container item xs={12}><br /></Grid>
                                            )
                                        }
                                    </Grid>
                                </Container>
                            </TabPanel>
                            <TabPanel value='2' className={classes.paddingTabPanel}>
                                <ServiceFinalization {...props} />
                            </TabPanel>
                        </TabContext>
                    </Grid>
                </Grid>
            </Container>
        </div>
    )
}

const mapStateToProps = state => ({
    evidences: state.TelematicsReducer.evidences,
    phoneTypeList: state.TelematicsReducer.phoneTypesList,
    userlogin: state.LoginReducer.list,
    isUserAuthenticated: state.LoginReducer.isAuthenticated,
    userToken: state.LoginReducer.token,
    userLanguage: state.LoginReducer.language
})

const mapDispatchToProps = dispatch => {
    return {
        tokenExpired: () => dispatch({ type: 'TOKEN_EXPIRED' }),
        cleanUserProfile: () => dispatch({ type: 'CLEAN_USER_PROFILE' }),
        actions: bindActionCreators(TelematicsActions, dispatch),
        navigationActions: bindActionCreators(navigationActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(TelematicsStyles)(TelematicsUploadEvidence))